<template>

  <v-layout
    justify-start
    style="
    width: 100%;
    "
  >

    <div
      style="
      position: relative;
      left: 0px;
      top: 0px;
      width: 100%;
      float: left;
      text-align: left"
    >

      <v-row>

     <v-card
          v-for="item in items"
          :key="item.id"

          width="450px"

          style="
          text-align: left;
          margin: 10px;
          "

      >
          <v-card-title>Tour ID: {{item.id}}</v-card-title>

          <v-card-text>
            <div>Fahrer: <b>{{item.driver_name}}</b></div>
            <div>Datum: <b>{{item.planed_date}}</b></div>
            <div>Fahrzeug: <b>{{item.car_description}}</b></div>
            <div>Bemerkungen zur Tour:</div>
            <div><b>{{item.note}}</b></div>
            <div 
             style=" 
              display: flex;
              justify-content: center;
              text-align: center;
              padding: 5px 0;"
            >
             <b>{{ item.pickup_qty }} / {{ item.planned_qty }}</b>
            </div>

            <VehicleCapacityBars 
              :total="item.total_capacity"
              :plannedTasks="item.planned_tasks"
            />
            <div style="padding: 20px;"></div>
            <cTimeLine
             v-bind:tour_id="item.id"
            ></cTimeLine> 


          </v-card-text>


        </v-card>

      </v-row>

    </div>

  </v-layout>

</template>

<script>
import cTimeLine from '../components/cTimeLine';
import VehicleCapacityBars from '../components/VehicleCapacityBars';

export default {
  name: "CardCurrentPickup",
  components: {
    cTimeLine,
    VehicleCapacityBars,
  },
  data() {
    return {
      items: [],

    }
  },
  created() {
    this.loadData()
  },
  methods:{
    async loadData(){
      console.log("loadData")
      var planed_date = this.$moment(Date.now()).format('DD.MM.YYYY');
      // Einstellungen
      var tourParam = {
        table: "tour",
        statement: "select",
        type: "list",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "WHERE planed_date='" + planed_date + "' and (pickup_date IS NULL OR pickup_date='')",
      }
     // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {};
      var result = await this.$func.queryAPI(tourParam, data);
      console.log(result);

      for (let tour of result) {
        const taskParam = {
          table: 'task',
          statement: 'select',
          type: 'list',
          where: 'false',
          selector: '',
          value: '',
          short: 'false',
          extension: "WHERE tour_id='" + tour.id + "'",
        };

        var taskResult = await this.$func.queryAPI(taskParam, data);
        console.log('tasks', taskResult);

        const sortedTasks = taskResult.sort((a, b) => a.tour_position - b.tour_position);
        const totalCapacity = parseInt(tour.car_capacity);
        const plannedTasks = sortedTasks.map(task => ({
          order_qty: parseInt(task.order_qty),
          pickup_qty: parseInt(task.pickup_qty || 0 ),
          pickup_date: task.pickup_date,
      
          
        }));
        const totalPlannedQty = plannedTasks.reduce((sum, task) => sum + task.order_qty, 0);
        const totalPickupQty = taskResult.reduce((sum, task) => sum + parseInt(task.pickup_qty || 0), 0);

        this.items.push({
          ...tour,
          total_capacity: totalCapacity,
          planned_tasks: plannedTasks,
          planned_qty: totalPlannedQty,
          pickup_qty: totalPickupQty,
        });
      }
    },
  },
  props: {

    extension: {
      type: String,
      default: ''
    },



  }



}
</script>

<style scoped>

</style>
